export const humanizeSnakeCase = (key: string) =>
  key.charAt(0).toUpperCase() + key.slice(1).replaceAll('_', ' ');
